  <!--优质店铺-->
<template>
  <div class="yzdiv" v-if="storeBody.shops && storeBody.shops.length > 0">
    <!-- 优质店铺名称 -->
    <div class="spanclass">
      <span>{{ constant.yzname }}</span>
    </div>
    <div class="store-body-container">
      <!--左侧图片-->
      <div class="picture">
        <img :src="storeOption.leftImg" />
      </div>
      <!--右侧商标-->
      <div class="right">
        <div class="brand">
          <a
            v-for="(shop, index) in shops"
            :key="index"
            :href="shop.url === '' ? 'javascript:void(0)' : shop.url"
            target="_blank"
          >
            <img :src="shop.imgSrc" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      constant: this.$store.state.malMainPageConfig.constant,
    };
  },
  computed: {
    storeBody: function () {
      return this.$store.state.malMainPageConfig.storeBody;
    },
    storeOption: function () {
      return this.$store.state.malMainPageConfig.storeBody.storeOption;
    },
    shops: function () {
      return this.$store.state.malMainPageConfig.storeBody.shops;
    },
  },
};
</script>

<style scoped lang="scss">
.yzdiv {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #f5f5f5;
}
.spanclass {
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 24px;
  color: #333333;
  float: left;
}
.store-body-container {
  display: flex;
  width: 1200px;
  justify-content: center;
  align-items: center;
  background: #ffffff70;
  margin-top: 24px;
}
.store-body-container .picture img {
  width: 276px;
  height: 592px;
  z-index: 1;
}
.right .brand {
  height: 596px;
  width: 924px;
}
.right div a img {
  margin-left: 35px;
  width: 426px;
  height: 294px;
}
</style>
